import type { RequestQuery, RequestQueryObject } from '../common';

export const getEventsKey = () => ['events'] as const;

export const getDispatchKey = (eventUuid: string) =>
  [...getEventsKey(), eventUuid, 'dispatches'] as const;

export const getDispatchListKey = (
  eventUuid: string,
  query: RequestQuery<RequestQueryObject> | undefined,
) => [...getDispatchKey(eventUuid), 'list', query] as const;

export const getEventTypesKey = () => [...getEventsKey(), 'types'] as const;
export const getEventTypesListKey = () =>
  [...getEventTypesKey(), 'list'] as const;
